import DownloadIcon from '@mui/icons-material/Download';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import { Link, Stack, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { FC, useEffect, useState } from 'react';
import { CSVLink } from 'react-csv';
import { useDispatch } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { getPoratlHost } from 'src/components/hooks/useUtil';
import { sendRequest } from 'src/hooks/useFetch';
import { useAppSelector } from 'src/store/hooks';
import { setMessage } from 'src/store/Message';
import { usePreferedDateFormat } from 'src/util/DateFormatter';

const VersionHistory: FC<any> = ({ openVersoinHistory, setOpenVersoinHistory, documentId, title }: any) => {
  const dispatch = useDispatch();
  const [versionHistoryDetails, setVersionHistoryDetails] = useState<any>([]);
  const [pageSize, setPageSize] = React.useState<number>(5);
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const { preferedDateFormat, userPreferedDateFormat } = usePreferedDateFormat();
  const [loading, setLoading] = useState<any>(false);
  const [csvDataDownload, setCsvDataDownload] = useState<any>([]);
  const downloadDateFormat = userPreferedDateFormat.includes('/')
    ? userPreferedDateFormat.replaceAll('/', '_')
    : userPreferedDateFormat.replaceAll('-', '_');

  const getVersionHistory = async () => {
    try {
      setLoading(true);
      const options: any = {
        endPointEnv: 'etmf',
        pathVariables: {
          study_id: studyId,
          country: selectedCountry,
          site_id: selectedSite,
          appName: process.env.REACT_APP_NAME,
          tmfDocId: documentId,
          audit_module_section: 'IMV REPORT'
        }
      };
      const result: any = await sendRequest('get_document_version_history', options);
      const updated = result.map((res: any) => {
        return { id: res.document_version.document_id, fileId: res.file_master_id, ...res.document_version };
      });
      const csvData = result.map((res: any) => {
        return {
          ...res.document_version,
          isf_doc_upload_date: moment(new Date(res.document_version.isf_doc_upload_date))
            .format(`${userPreferedDateFormat.toUpperCase()}, hh:mm:ss A`)
            .toString()
        };
      });
      setVersionHistoryDetails(updated);
      setCsvDataDownload(csvData);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      setVersionHistoryDetails([]);
      if (error && error?.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error && error.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
    }
  };

  useEffect(() => {
    getVersionHistory();
  }, []);

  const getVesionBasedDocumentDetails = async (vd: any) => {
    try {
      const options = {
        endPointEnv: 'etmf',
        study_id: studyId,
        pathVariables: {
          site_id: selectedSite,
          country: selectedCountry,
          tmfDocumentId: vd.tmf_document_id,
          docVersionNumber: vd.tmf_doc_version_number,
          documentId: vd.document_id,
          appName: process.env.REACT_APP_NAME
        }
      };
      const result: any = await sendRequest('get_documents_by_studyid_tmf_document_id_tmf_doc_version_number', options);
      window.parent.postMessage(
        {
          action: 'PUSH_APP',
          slug_id: process.env.REACT_APP_ETMF_SLUG,
          viewerDocument: {
            document_id: result.document_data.id,
            file_master_id: result.file_master.id,
            study_id: studyId,
            site_id: selectedSite,
            country: selectedCountry
          }
        },
        getPoratlHost()
      );
      if (openVersoinHistory) {
        setOpenVersoinHistory(false);
      }
    } catch (error: any) {
      setLoading(false);
      if (error && error?.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error && error.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      } else {
        dispatch(setMessage({ msgDetails: 'Error while getting document data', severity: 'error' }));
      }
    }
  };

  const gridFunc = (versionDetails: any) => {
    getVesionBasedDocumentDetails(versionDetails);
    // handleClose();
    // setDocumentToDisplay1(versionDetails);
    // setDataGridComponent(false);
  };

  const columns: GridColDef[] = [
    {
      field: 'tmf_doc_version_number',
      headerName: 'Version',
      minWidth: 230,
      flex: 1,
      renderCell: (params: any) => (
        <Link onClick={() => gridFunc(params.row)}>{params.value.toFixed(1).toString()}</Link>
      )
    },
    {
      field: 'tmf_doc_last_modified_by',
      headerName: 'Name',
      minWidth: 230,
      flex: 1
    },
    {
      field: 'tmf_doc_upload_date',
      headerName: 'Date Modified',
      minWidth: 180,
      flex: 1,
      valueFormatter: (params: any) => {
        return preferedDateFormat(params.value?.split('T')[0]);
      }
    }
  ];

  const handleClose = () => {
    setOpenVersoinHistory(false);
  };

  function TabPanel(props: { [x: string]: any; children: any; value: any; index: any }) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  const headersForCSV = [
    { label: 'Version', key: 'tmf_doc_version_number' },
    { label: 'Name', key: 'tmf_doc_last_modified_by' },
    { label: 'Date Modified', key: 'tmf_doc_upload_date' }
  ];
  const handlePrint = () => {
    setTimeout(() => {
      window.print();
    }, 300);
  };

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
  };

  return (
    <div>
      <div className="query-modal">
        <PopupComponent aria-labelledby="customized-dialog-title" open={openVersoinHistory} maxWidth="lg">
          <DialogContent dividers className="audit-history-modal" sx={{ p: 2, width: '800px' }}>
            <div className="audit-card">
              <Grid container>
                <Grid item md={12}>
                  <Box sx={{ bgcolor: 'background.paper', pt: 0 }}>
                    <Grid container>
                      <Grid item md={10}>
                        <h2>Version History - {title}</h2>
                      </Grid>
                      <Grid
                        item
                        md={2}
                        display="flex"
                        justifyContent="flex-end"
                        className="print-actions"
                        id="no-print"
                      >
                        <Button onClick={e => handlePrint()} variant="text" className="grey-btn">
                          <LocalPrintshopIcon />
                        </Button>
                        <Button variant="text" className="grey-btn" sx={{ pt: 2 }}>
                          <CSVLink
                            headers={headersForCSV}
                            data={csvDataDownload}
                            filename={`VersionHistory_${moment(new Date()).format(
                              `${downloadDateFormat.toUpperCase()} HH:mm:ss`
                            )}.csv`}
                          >
                            <DownloadIcon className="grey-btn" />
                          </CSVLink>
                        </Button>
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item md={12}>
                        <div style={{ height: 360, width: '100%', minWidth: '760px' }}>
                          <DataGrid
                            rows={versionHistoryDetails}
                            columns={columns}
                            pageSize={pageSize}
                            onPageSizeChange={newPageSize => setPageSize(newPageSize)}
                            rowsPerPageOptions={[5, 10, 20]}
                            pagination
                            disableSelectionOnClick
                            initialState={{
                              sorting: {
                                sortModel: [{ field: 'updated_on', sort: 'desc' }]
                              }
                            }}
                            loading={loading}
                          />
                        </div>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
                <Grid item md={12} id="no-print">
                  <Grid container spacing={2}>
                    <Grid item md={12} display="flex" justifyContent="flex-end">
                      <Stack direction="row" spacing={2}>
                        <Button
                          variant="text"
                          href="#contained-buttons"
                          className="grey-btn"
                          onClick={handleClose}
                          disabled={loading}
                        >
                          Close
                        </Button>
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </DialogContent>
        </PopupComponent>
      </div>
    </div>
  );
};

export default VersionHistory;
